import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class FeedService {
  constructor(
    private http: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private message: NzMessageService,
  ) {}

  getFeedByMember(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/feed?where[member][equals]=${id}&-createdAt`,
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Feed');
            reject(error);
          },
        );
    });
  }

  getFeedByOrder(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/feed?sort=-createdAt&page=${page}&limit=${pageSize}`,
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Feed');
            reject(error);
          },
        );
    });
  }

  addPostByMember(data: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.post(`${SETTINGS.CMS_API}/api/feed`, data).subscribe(
        (response) => {
          this.message.create('success', 'New post has been published!');
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve Feed');
          reject(error);
        },
      );
    });
  }

  updatePost(data: any, id: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .patch(`${SETTINGS.CMS_API}/api/feed/${id}`, data)
        .subscribe(
          (response) => {
            this.message.create('success', 'Post has been updated!');
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to Update Feed');
            reject(error);
          },
        );
    });
  }

  deletePost(id: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.delete(`${SETTINGS.CMS_API}/api/feed/${id}`).subscribe(
        (response) => {
          this.message.create('success', 'Post has been deleted!');
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to Update Feed');
          reject(error);
        },
      );
    });
  }
}
